<template>
    <BaseDialog v-model:open="open" :title="title" dialog-content-class="md:!max-w-md">
        <div class="flex flex-col gap-6 p-8 md:p-10">
            <div class="flex flex-col gap-3">
                <h2 class="display-small-serif text-valence-stone-900" data-testid="dialog-title">{{ title }}</h2>
                <p v-if="text" class="body text-valence-stone-500">{{ text }}</p>
                <slot></slot>
            </div>
            <div class="flex flex-col gap-1">
                <BaseButton theme="primary" class="base-btn-dark w-full" :disabled="confirmDisabled" data-testid="confirm-button" @click="onConfirm">
                    {{ confirmLabel }}
                </BaseButton>
                <button type="button" class="body text-valence-stone-900 hover:text-valence-stone-500 py-2.5" data-testid="cancel-button" @click="onCancel">
                    {{ cancelLabel }}
                </button>
            </div>
        </div>
    </BaseDialog>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import BaseDialog from "~vue/components/BaseDialog.vue";

interface Props {
    title: string;
    text?: string;
    confirmLabel?: string;
    cancelLabel?: string;
    confirmDisabled?: boolean;
}

withDefaults(defineProps<Props>(), {
    text: "",
    confirmLabel: "Submit responses",
    cancelLabel: "Continue editing",
    confirmDisabled: false,
});

const emit = defineEmits<{ confirm: []; cancel: [] }>();

const open = defineModel<boolean>("open", { default: false });

function onConfirm() {
    emit("confirm");
}

function onCancel() {
    open.value = false;
    emit("cancel");
}
</script>
